import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { CircularProgress, Box, Typography } from "@mui/material";

export const SsoCallbackPage = () => {
  const navigate = useNavigate();
  const { setToken, setUser, fetchUser } = useContext(AuthContext);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const error = params.get("error");
    if (token) {
      if (typeof setToken === "function") setToken(token);
      if (typeof fetchUser === "function") fetchUser(token);
      navigate("/", { replace: true });
    } else {
      // Show error or redirect to login
      navigate("/", { replace: true, state: { error } });
    }
  }, [navigate, setToken, fetchUser]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Signing in with Microsoft...
        </Typography>
      </Box>
    </Box>
  );
};
